/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Tab_PublishedInputs */

const en_admin_posts_tab_published = /** @type {(inputs: Admin_Posts_Tab_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const zh_admin_posts_tab_published = /** @type {(inputs: Admin_Posts_Tab_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发布`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Admin_Posts_Tab_PublishedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_tab_published = /** @type {((inputs?: Admin_Posts_Tab_PublishedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Tab_PublishedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_tab_published(inputs)
	return zh_admin_posts_tab_published(inputs)
});
export { admin_posts_tab_published as "admin.posts.tab_published" }